export default __webpack_public_path__ + "static/media/corporate-scrollover.e89ce804.jpg";